import BaseApi from "./BaseApi";

class helpApi extends BaseApi {
  async getAllTickets(data) {
    return await this.API({
      url: "/help/get-all-tickets",
      data: data,
      method: "post",
    });
  }

  async deleteTicket(data) {
    return await this.API({
      url: "/help/delete-ticket",
      data: data,
      method: "post",
    });
  }

  async updateStatus(data) {
    return await this.API({
      url: "/help/update-status",
      data: data,
      method: "post",
    });
  }

  async sendTicketMsg(data) {
    return await this.API({
      url: "/help/send-ticket-msg",
      data: data,
      method: "post",
    });
  }

}

export default helpApi;
